
import React, { createContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

export const UtmContext = createContext(null);

const UTM_FIELDS = {
  UTM_SOURCE: { queryParam: "utm_source", defaultValue: "direct" },
  UTM_MEDIUM: { queryParam: "utm_medium", defaultValue: "none" },
  UTM_CAMPAIGN: { queryParam: "utm_campaign", defaultValue: "none" },
  UTM_TERM: { queryParam: "utm_term", defaultValue: "none" },
  UTM_CONTENT: { queryParam: "utm_content", defaultValue: "none" },
};

const buildUtmData = (search) => {
  const params = new URLSearchParams(search);
  const utmData = { URL_UTM: window.location.href };

  Object.entries(UTM_FIELDS).forEach(([key, config]) => {
    utmData[key] = params.get(config.queryParam) || config.defaultValue;
  });

  return utmData;
};

export const UtmProvider = ({ children }) => {
  const location = useLocation();
  const [utmData, setUtmData] = useState(null);

  useEffect(() => {
    if (utmData) return;
    setUtmData(buildUtmData(location.search));
  }, [location.search, utmData]);

  return (
    <UtmContext.Provider value={utmData}>
      {children}
    </UtmContext.Provider>
  );
};
